import React, { useState } from "react";
import { IBusinessType } from "../type/BusinessTypeInterface";
import { editStateAgreementBusinessType } from "../atoms/atoms";
import { useRecoilValue } from "recoil";
import { useFormContext } from "react-hook-form";
import TextInputLabelHookForm from "components/TextInputLabelHookForm";
import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";
import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import { PERMISSIONS } from "modules/PermissionsConstants";

export default function BusinessTypeDetails(props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: IBusinessType | undefined;
}) {
  // Props drilled
  const { data, setChanges } = props;

  // Permission
  const userPermissions = useRecoilValue(permissionsSelector);
  const deletePermission = userPermissions.includes(
    PERMISSIONS.permission_utilities_configureagreement_businesstype_delete
  );

  // Recoil Hook
  const edit = useRecoilValue(editStateAgreementBusinessType);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks
  const [inputData, setInputData] = useState(data?.businessTypeName || "");
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);
  return (
    <div className="bg-bgDB">
      <div className="m-2 bg-white box-shadow h-full">
        <div className="grid grid-cols-1 md:grid-cols-5 mx-3 pb-2 gap-2 gap-x-2 py-2">
          <div className="col-span-3 my-1">
            <TextInputLabelHookForm
              name="businessTypeName"
              label="Business Type Name"
              type="text"
              onChange={(e) => {
                setInputData(e.target.value);
                if (
                  e.target.value.length === 0 ||
                  (e.target.value === data?.businessTypeName &&
                    checkBoxChanges === data?.isActive)
                ) {
                  setChanges(false);
                } else {
                  setChanges(true);
                }
                e.target.value = e.target.value.replace(/\s+/g, " ");
              }}
              required={true}
              className={
                formMethods.formState.errors.businessTypeName &&
                formMethods.formState.errors.businessTypeName.message &&
                "border-2 border-red-500 col-span-2 "
              }
              register={formMethods.register("businessTypeName", {
                required: {
                  value: true,
                  message: "Required Field",
                },
              })}
              maxLength={255}
            />
          </div>

          {edit && (
            <div className="col-span-2 my-1 mx-3">
              <CheckBoxLabelHookForm
                name="isActive"
                label={
                  checkBoxChanges
                    ? "Uncheck to Deactivate"
                    : "Check to Activate"
                }
                type="checkbox"
                validation={{
                  required: {
                    value: false,
                    message: "Required Field",
                  },
                }}
                onClick={(e) => {
                  if (!deletePermission && data?.isActive) return;
                  setCheckBoxChanges(e.target.checked);
                  if (
                    inputData?.length === 0 ||
                    (e.target.checked === data?.isActive &&
                      inputData === data?.businessTypeName)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                }}
                disabled={!deletePermission && data?.isActive ? true : false}
                register={register}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
